// --- React
import React from "react";
// --- External UI Libraries
import Input from "@dtci/spellbook/Input";
// --- Utilities
import moment from "moment-timezone";

/**
 * EditableDateRenderer Component
 *
 * Cell renderer for AG Grid that shows a date picker when in edit mode,
 * or formatted date when not editing.
 *
 * @param {Function} getEditingRows - Function that returns current editing rows state
 * @param {Function} onValueChange - Callback when value changes (data, fieldName, newValue)
 * @param {string} fieldName - The field name being edited
 * @param {Object} options - Optional config: { displayFormat, inputFormat }
 * @returns {Function} The cell renderer component
 */
export const EditableDateRenderer = (
  getEditingRows,
  onValueChange,
  fieldName,
  options = {},
) => {
  const { displayFormat = "DD-MMM-YYYY", inputFormat = "YYYY-MM-DD" } = options;

  const formatDateForDisplay = (value) => {
    if (!value) return "";
    const date = moment(value);
    return date.isValid() ? date.format(displayFormat) : "";
  };

  const formatDateForInput = (value) => {
    if (!value) return "";
    const date = moment(value);
    return date.isValid() ? date.format(inputFormat) : "";
  };

  const Renderer = ({ value, data }) => {
    const editingRows = getEditingRows ? getEditingRows() : {};
    const isEditing = editingRows[data?.id];

    if (!isEditing) {
      return <span>{formatDateForDisplay(value)}</span>;
    }

    const handleChange = (e) => {
      const newValue = e.target.value;
      if (onValueChange) {
        onValueChange(data, fieldName, newValue);
      }
    };

    return (
      <Input
        value={formatDateForInput(value)}
        onChange={handleChange}
        type="date"
        width="auto"
        style={{ minWidth: 140 }}
      />
    );
  };

  return Renderer;
};
